<template>
  <UiModal modal-styles="mobile-bottom tablet-bottom" @close="onClose">
    <div
      class="confirm-body"
      :class="[{ small: smallStyle, 'tablet-fixed': tabletFixed }, customClass]"
      :style="`--tablet-fixed: ${tabletFixed}`"
      @click.stop
    >
      <RenderHTML
        tag-wrapper="h3"
        :seotext="title"
        class-wrapper="title text-h3-bold-up"
      />
      <RenderHTML
        :seotext="description"
        class-wrapper="description text-body-m-book"
      />
      <div class="controls">
        <ui-ui-button
          v-if="cancelText"
          :type="firstButtonStyle"
          :size="buttonBig ? 'large' : 'medium'"
          :resize="true"
          @click="closeAction"
        >
          {{ cancelText }}
        </ui-ui-button>
        <ui-ui-button
          :type="secondButtonStyle"
          :size="buttonBig ? 'large' : 'medium'"
          :resize="true"
          @click="applyAction"
        >
          {{ applyText }}
        </ui-ui-button>
      </div>
    </div>
  </UiModal>
</template>

<script setup lang="ts">
import RenderHTML from '~/components/ui/RenderHTML.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  cancelText: {
    type: String,
    default: '',
  },
  applyText: {
    type: String,
    default: 'Применить',
  },
  onApply: {
    type: Function as any,
    required: true,
  },
  onCloseAction: {
    type: Function as any,
    default: () => {},
  },
  autoWidth: Boolean,
  smallStyle: Boolean,
  tabletFixed: String,
  firstButtonStyle: {
    type: String,
    default: 'outline',
  },
  secondButtonStyle: {
    type: String,
    default: 'primary',
  },
  buttonBig: Boolean,
  customClass: {
    type: String,
    default: '',
  },
});
const emit = defineEmits(['close']);
const onClose = () => {
  emit('close');
};

const applyAction = () => {
  props.onApply();
  onClose();
};

const closeAction = () => {
  props.onCloseAction();
  onClose();
};
</script>
<style lang="scss" src="./confirm-modal.scss" scoped />
